import React from 'react';
// Modules
import {
  Box, Button, Text, VStack,
} from '@chakra-ui/react';
import Image from 'next/image';

const Banner: React.FC = () => (
  <Box
    bgColor="gray.200"
    borderRadius={['none', '3xl']}
    h="400px"
    mx={['-4', '0']}
    overflow="hidden"
    position="relative"
  >
    <Image layout="fill" objectFit="cover" src="/images/promotion-banner.png" />
    <VStack
      alignItems="flex-start"
      bgColor="blackAlpha.700"
      bottom="0"
      left="0"
      justifyContent="center"
      padding={['4', '8']}
      position="absolute"
      right="0"
      spacing="6"
      top="0"
    >
      <Text color="white" fontSize="2xl" fontWeight="medium" maxW="400px">
        Kumpul dan tukarkan poin belanjamu dengan hadiah menarik tiap bulan!
      </Text>
      <Button
        as="a"
        colorScheme="primary"
        href="https://shopee.co.id/utamastationerytulungagung"
        rel="noopener noreferrer"
        target="_blank"
        textColor="black"
      >
        Belanja Sekarang
      </Button>
    </VStack>
  </Box>
);

export default Banner;
